import { useEffect, useState } from "react"
import InputTextField from "../../utilities/helperComponents/InputTextField"
import OutlineButton from "../../utilities/helperComponents/OutlineButton";
import PrimaryButton from "../../utilities/helperComponents/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { captureCurrentFilters } from "../../features/leadTableFiltersSlice";
import { addFilter } from "../../features/filterSlice";
import { filterLeadsPayload } from "../../utilities/leadFunctions";
import { saveFilter } from "../../utilities/filterFunctions";

function SaveCurrentLeadTableFilter({}){
    const [newFilter, setNewFilter] = useState('')
    const [filterErrorMsg, setFilterErrorMsg] = useState('')

    const dispatch = useDispatch()

    /**
     * @type {leadFilterOptions}
     */
    const {date_assigned, lead_age, state, last_contacted, never_contacted, amount_contacted, tags, lead_type, lead_level, lead_status, predefined_filter} = useSelector((state) => state.leadTableFilter)
    const agentInfo = useSelector((state) => state.agent.userData)
    const agentFilters = useSelector((state) => state.filters.filters)

    const agentFilterNames = agentFilters.map( f => f.name)

    const addNewFilter = async () => {
        try {
            const {filterListOptions, filterRangeOptions, sortOptions} = filterLeadsPayload(date_assigned, lead_age, state, last_contacted, never_contacted, amount_contacted, tags, lead_type, lead_level, lead_status, predefined_filter, -1, -1)
            const customFilterData = await saveFilter(agentInfo.agentId, agentInfo.teamId, newFilter, filterListOptions, filterRangeOptions, sortOptions, predefined_filter.params)

            dispatch(addFilter(customFilterData))
            dispatch(captureCurrentFilters(false))

        } catch (error) {
            console.error('Error saving filter:', error);
        }
    }

    useEffect(()=>{
        let errorMsg = ''
        if(agentFilterNames.includes(newFilter)){
            errorMsg = 'This filter name already exists.'
        }

        setFilterErrorMsg(errorMsg)
    }, [newFilter])

    return (
        <div style={{ width: '40%', padding: 32, background: 'var(--Colors-Neutrals-White, white)', overflow: 'hidden', borderRadius: "5px", border: "2px solid #E4E4E4", flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex', marginTop: '100px' }}>
            <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'flex' }}>
                <div style={{ alignSelf: 'stretch', paddingBottom: 16, borderBottom: '2px #F1F1F1 solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'flex' }}>
                    <div style={{ textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', color: 'var(--Colors-Foreground-fg-primary-(900), #2F2F2F)', fontSize: 26, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>Save Filter</div>
                </div>
            </div>
            <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 32, display: 'flex' }}>
                <div style={{ textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', color: 'var(--Colors-Neutrals-Neutral-1, #707070)', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', letterSpacing: 0.07, wordWrap: 'break-word' }}>All filter selections will be saved in this filter that you can apply later.</div>
                <div style={{ alignSelf: 'stretch', minHeight: 48, borderRadius: 5, justifyContent: 'flex-start', alignItems: 'center', gap: 32, display: 'inline-flex' }}>
                    <div style={{ width: '100%', height: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                        <div style={{ alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'inline-flex' }}>
                            <div style={{ width: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'inline-flex' }}>
                                <div style={{ alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 20, display: 'inline-flex', width: '100%' }}>
                                    <InputTextField
                                        inputLabel='Filter Name'
                                        inputValue={newFilter}
                                        changeHandler={e => setNewFilter(e.target.value)}
                                        errorMsg={filterErrorMsg}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                    <div>
                        <OutlineButton
                            buttonLabel='Cancel'
                            clickHandler={ _ => dispatch(captureCurrentFilters(false))}
                            buttonClass='q-outlineButton-destructive'
                        />
                    </div>

                    <div style={{marginRight: '30px'}}>
                        <PrimaryButton
                            buttonLabel='Save'
                            disabled={filterErrorMsg.length > 0 || newFilter.length === 0}
                            buttonClass={filterErrorMsg.length > 0 || newFilter.length === 0 ? 'q-bulk-action-dial-disabled-solid' : 'q-bulk-action-dial'}
                            clickHandler={ _ => addNewFilter()}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SaveCurrentLeadTableFilter